
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residential-storage",
      function () {
        return require("private-next-pages/residential-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residential-storage"])
      });
    }
  